import React from 'react'
import styled from 'styled-components'
import InnerWrapper from '../../elements/innerWrapper'
import Grid, { Wrapper } from '../../elements/grid'
import { breakpoint } from '../../shared/theme'

const ContentInner = styled(Wrapper)`
	grid-column: -1 / 1;
	grid-template-columns: repeat(12, minmax(0, 1fr));

	@media ${breakpoint('tablet')} {
		grid-column: 3 / span 10;
		grid-template-columns: repeat(10, minmax(0, 1fr));
	}

	p {
		@media ${breakpoint('laptop')} {
			line-height: 1.7;
		}
	}
`

const SinglePostInner = ({ children }) => {
	return (
		<InnerWrapper>
			<Grid>
				<ContentInner>{children}</ContentInner>
			</Grid>
		</InnerWrapper>
	)
}

export default SinglePostInner
export { ContentInner }
